import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
import sections from 'src/styles/sections';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  loginPageForm: {
    '& .MuiGrid-root:last-child': {
      paddingTop: '10px'
    }
  },
  loginPageSocials: {
    marginBottom: '32px',
    ["".concat(breakpointsFunc.breakpoints.down('lg'), " and (orientation: portrait)")]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '360px',
      '& .MuiButton-social': {
        marginLeft: '0',
        width: '100%'
      },
      '& .MuiButton-social + .MuiButton-social': {
        marginTop: '10px'
      }
    }
  },
  loginPageDivider: {
    textTransform: 'uppercase',
    color: palette.shades[500],
    width: '360px',
    textAlign: 'center',
    position: 'relative',
    marginBottom: '32px',
    '&:after, &:before': {
      content: "''",
      height: '1px',
      backgroundColor: palette.shades[500],
      display: 'block',
      width: '44%',
      top: '50%',
      position: 'absolute'
    },
    '&:after': {
      right: '0'
    },
    '&:before': {
      left: '0'
    }
  },
  actionButtonWrapper: {
    marginTop: '10px',
    textAlign: 'right'
  }
}));
export default useStyles;